import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';

import { GET_RECEIPT_RESPONSE } from 'actions/baskets';
import {
  GET_USER_BEHAVIORAL_DISCOUNTS_RESPONSE,
  CLAIM_USER_BEHAVIORAL_DISCOUNT_RESPONSE,
} from 'lib/constants/v3Actions';

const INITIAL_USER_BEHAVIORAL_DISCOUNTS = [];

const initialState = { isLoading: true };

const addUserBehavioralDiscountsForMenu = (state, menuSlug, userBehavioralDiscounts) => {
  return {
    ...state,
    isLoading: false,
    [menuSlug]: userBehavioralDiscounts,
  };
};

const shouldAddUserBehavioralDiscounts = action => {
  return action.response && action.response.behavioralDiscounts;
};

const mergeIsClaimedIntoUserBehavioralDiscounts = (
  userBehavioralDiscounts,
  userBehavioralDiscountClaims
) => {
  const claimStateByDiscountId = userBehavioralDiscountClaims.reduce((acc, claim) => {
    const discountId = claim.userBehavioralDiscountId;
    const isClaimed = claim.isClaimed;

    acc[discountId] = isClaimed;
    return acc;
  }, {});

  return userBehavioralDiscounts.map(userBehavioralDiscount => ({
    ...userBehavioralDiscount,
    isClaimed: claimStateByDiscountId[userBehavioralDiscount.id],
  }));
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_BEHAVIORAL_DISCOUNTS_RESPONSE:
      return addUserBehavioralDiscountsForMenu(
        state,
        action.response.menuSlug,
        action.response.userBehavioralDiscounts
      );
    case GET_RECEIPT_RESPONSE: {
      if (shouldAddUserBehavioralDiscounts(action)) {
        return addUserBehavioralDiscountsForMenu(
          state,
          action.response.menuSlug,
          action.response.behavioralDiscounts
        );
      }
      return state;
    }
    case CLAIM_USER_BEHAVIORAL_DISCOUNT_RESPONSE: {
      const userBehavioralDiscounts = selectUserBehavioralDiscountsForMenu(
        state,
        action.params?.menuSlug
      );
      const userBehavioralDiscountClaims = action.response.userBehavioralDiscounts;

      return addUserBehavioralDiscountsForMenu(
        state,
        action.params?.menuSlug,
        mergeIsClaimedIntoUserBehavioralDiscounts(
          userBehavioralDiscounts,
          userBehavioralDiscountClaims
        )
      );
    }
    default:
      return state;
  }
};

export const selectUserBehavioralDiscountsForMenu = (state, menuSlug) =>
  get(state, menuSlug, INITIAL_USER_BEHAVIORAL_DISCOUNTS);

export const selectUserBehavioralDiscountsForPromotionalDisplay = createSelector(
  [(state, menuSlug) => selectUserBehavioralDiscountsForMenu(state, menuSlug)],
  userBehavioralDiscounts =>
    userBehavioralDiscounts.filter(
      userBehavioralDiscount => userBehavioralDiscount.shouldDisplayBanner
    )
);
export const selectUserBehavioralDiscountsIsLoading = state => state.isLoading;

export const selectClaimedUserBehavioralDiscountIdForMenu = createSelector(
  [(state, menuSlug) => selectUserBehavioralDiscountsForMenu(state, menuSlug)],
  userBehavioralDiscounts => {
    const claimedDiscount = userBehavioralDiscounts.find(
      userBehavioralDiscount => userBehavioralDiscount.isClaimed
    );
    return claimedDiscount ? claimedDiscount.id : null;
  }
);
